import { formatPrice } from '../formatting';
import getSubscriptionIntervalWithSlash from '../formatting/getSubscriptionIntervalWithSlash';

export default function getPriceLabel(
  { amount = 0, currency = 'usd', interval = '', intervalCount = 0, type = '', isNegated = false },
  locale = 'en-US',
) {
  const formattedPrice = formatPrice({
    amount: amount,
    currency: currency,
    locale,
    style: 'currency',
  });

  const priceLabel = isNegated === true ? `-${formattedPrice}` : formattedPrice;

  if (type === 'subscription') {
    return `${priceLabel} ${getSubscriptionIntervalWithSlash(interval, intervalCount)}`;
  }

  return priceLabel;
}
